<template>
  <v-card>
    <v-card-title>
      <div class="flex-grow-1">Rx Claims</div>
      <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :loading="loading" :headers="headers" :items="patient_data" :search="search">
      <template v-slot:item.AMOUNT_DEC="{ item }">
        {{ item.AMOUNT }}
      </template>

      <template v-slot:no-data> No Claims </template>
    </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Rx',
  props: ['patient', 'insurance', 'recordLimit'],

  data() {
    return {
      search: '',
      loading: false,
      headers: this.generateHeaders(),
      patient_data: [],
    };
  },
  mounted() {
    this.getClaims();
  },
  methods: {
    async getClaims() {
      this.loading = true;
      await axios
        .get(`/api/patient/claims/rx/${this.insurance}/${this.patient}/${this.recordLimit}`)
        .then((response) => {
          this.patient_data = response.data;
          this.loading = false;
        });
    },
    generateHeaders() {
      const headers = [
        { text: 'Claim ID', sortable: false, value: 'RX_CLAIM_ID' },
        { text: 'Claim Date', value: 'EFFECTIVE_DATE' },
        { text: 'Drug Name', value: 'DRUG_NAME' },
        { text: 'Qty', value: 'QTY' },
        { text: 'Prescriber', value: 'PRESCRIBER_NAME' },
        { text: 'Interchange Drug', value: 'INTERCHANGE_DRUG' },
      ];

      if (this.$route.path !== '/member') {
        headers.push({ text: 'Prescriber NPI', value: 'PRESCRIBER_NPI' });
      }

      return headers;
    },
  },
};
</script>
